const QuestStore = {
  namespaced: true,
  state: {
    lastSavedQuestIndex: 0,
    lastSavedSubQuestIndex: 0,
  },
  mutations: {
    saveCurrentQuest(state, {quest, subQuest}) {
      state.lastSavedQuestIndex = quest
      state.lastSavedSubQuestIndex = subQuest
    },
    setLastSavedQuestIndex(state, {quest}) {
      state.lastSavedQuestIndex = quest
    },
    setLastSavedSubQuestIndex(state, {subQuest}) {
      state.lastSavedSubQuestIndex = subQuest
    },
  },
}

export default QuestStore
